<ds-tabs-group
    indicator="underline"
    fullWidthTabs="false"
    size="small"
    variant="horizontal"
    scrollSpeed="slow"
    showBorderBottom="true"
    class="arrow-alignment"
    [activeTab]="activeName()"
    [scrollable]="true"
    (activeTabChanged)="selected($event)">
    @for (tab of viewListItems(); track tab.id) {
        <ds-tab [name]="tab.id.toString()" [disabled]="tab.disabled">
            <ng-template let-selected dsTabHeader>
                <a [msLink]="tab" [vnSpeculativeLink]="tab.url">
                    <span [attr.data-menu-item-id]="tab.id">
                        {{ tab.title }}
                        @if (tab.hasTooltip) {
                            <div
                                [popper]="tooltipPopper"
                                [popperShowOnStart]="true"
                                [popperAppendTo]="'event-details'"
                                [popperPlacement]="NgxPopperjsPlacements.BOTTOM"
                                [popperBoundaries]="'event-details'"
                                [popperApplyClass]="'tab-bar-tooltip-popper'"
                                [popperApplyArrowClass]="'withoutArrow'"
                                [popperPreventOverflow]="true"
                                [popperHideOnClickOutside]="true"
                                (popperOnShown)="onPopperShown()"></div>
                        }
                    </span>
                    @if (tab.hasNewBadge) {
                        <ds-badge variant="primary" size="medium">{{ sitecore.globalMessages.NewBadgeText }}</ds-badge>
                    }
                    @if (tab.count) {
                        @if (tab.showSignPost) {
                            <ms-priceboost-count-signpost [count]="tab.count" />
                        } @else {
                            <ds-notification-bubble
                                msThemedNotification
                                size="medium"
                                [isSelected]="tab.active ?? false"
                                [selectedVariant]="selectedTabBubbleVariant"
                                [themedVariant]="variant"
                                [inverse]="false">
                                {{ tab.count }}
                            </ds-notification-bubble>
                        }
                    }
                </a>
            </ng-template>
        </ds-tab>
    }
    <ds-divider />
</ds-tabs-group>
@if (tooltip().shouldShow) {
    <popper-content #tooltipPopper>
        <ms-onboarding-tooltip [showHelp]="tooltip().shouldShow" [message]="tooltip().message" (closeClicked)="closeTooltip()" />
    </popper-content>
}
